export const en = {
    Lang_cs: "Česky",
    Lang_en: "English",
    button_Pokracovat: "Continue",
    button_Close: "Close",
    button_Ok: "Ok",
    SetFirstPassword_DokladFill: "Enter papers number to continue, please.",
    button_Update: "Edit",
    button_Save: "Save",
    button_cancel: "Cancel",
    TypOvereniSubjektu: "Verification method",
    TypOvereniSubjektu_DOKLAD_CISLO: "Papers number",
    TypOvereniSubjektu_JMENO_PRIJMENI_DATUMNAR: "Name, surname, and date of birth",
    SetFirstPassword_Overeni: "To continue, please fill in the verification details",
    SetFirstPassword_HesloNastaveno: "Password was set",
    Form_HeslaNeshoduji: "Passwords are different",
    TypDokladu_ID: "Identity Card",
    TypDokladu_P: "Passport",
    TypDokladu_OSTATNI: "Other",
    TypDokladu_IR: "Residence permit",
    TypDokladu_VS: "Visa",
    TypDokladu_PS: "Residence permit label",
    TypDokladu_RP: "Driving licence",
    DokladForm_idDoklad_required: "Papers number is required",
    DokladForm_idDoklad_minLength: "Minimum length of Papers number is 8 characters.",
    DokladForm_idDoklad_maxLength: "Maximum length of Papers number is 9 characters.",
    DokladForm_typDokladu_required: "Papers type is required",
    DokladForm_typOvereniSubjektu_required: "Verification method is required",
    DokladForm_jmeno_required: "First name is required",
    DokladForm_prijmeni_required: "Surname is required",
    DokladForm_datumNarozeni_required: "Date of birth is required",
    DokladForm_cisloDokladu: "Papers number",
    DokladForm_jmeno: "First name",
    DokladForm_prijmeni: "Surname",
    DokladForm_datumNarozeni: "Date of birth",
    NewPasswordForm_newPassword: "New pasword",
    NewPasswordForm_newPassword_repeat: "Re-enter new pasword",
    UserAgreementFormSection_agreement: "I agree to {1} and {2}.",
    UserAgreementFormSection_gdpr: "processing of personal data",
    UserAgreementFormSection_terms: "terms of use of the portal",
    UserAgreementFormSection_agreement2: "I agree to {1}.",
    UserAgreementFormSection_gdpr_and_terms: "processing of personal data and terms of use of the portal",
    UserAgreementFormSection_gdpr_detail: "Agree to the processing of personal data",
    UserAgreementFormSection_terms_detail: "Agree to the terms of use of the portal",
    ProcessLoginForm_cisloDokladu_required: "Enter papers number ",
    ProcessLoginForm_finish_disabled: "To continue, please verify your email",
    Form_agreement_required: "You have to agree to the processing of personal data and tems of use of the portal.",
    NewPasswordForm_newPassword_required: "Password is required",
    NewPasswordForm_newPassword_repeat_required: "Re-entering password is required",
    ResetPasswordPage_obnoveniHesla: "Reset password",
    ResetPasswordPage_done: "Instructions for reset password were sent to your registered e-mail.",
    ResetPasswordForm_login: "Username",
    ResetPasswordForm_login_required: "Username is required",
    ResetPasswordForm_captcha_required: "Confirm You are not a robot. ",
    Altcha_label: "I'm not a robot",
    Altcha_verified: "Verified",
    Altcha_verifying: "Verifying...",
    Altcha_error: "Verification failed.",
    Altcha_expired: "Verification expired.",
    ResetPasswordForm_info: "Enter username. Instruction for reset password will be sent to your registered e-mail.",
    ResetPasswordForm_button_obnovitHeslo: "Reset password",
    PasswordChangePage_title: "Password setting",
    NewPasswordForm_button_nastavitHeslo: "Set password",
    PasswordChangePage_hesloNastaveno: "The password was set. You can log in.",
    PasswordChangePage_continueLogin: "Continue to login",
    TypAutentizace_JMENO_HESLO: "Username ({0}) and password",
    TypAutentizace_NIA: "Identita občana",
    TypAutentizace_MOJE_ID: "MojeID",
    TypAutentizace_ISDS: "ISDS",
    TypAutentizace_JMENO_HESLO_INVALID: "Name and password not set.",
    TypAutentizace_NIA_INVALID: "eidentita not connected.",
    TypAutentizace_MOJE_ID_INVALID: "Acount MojeID not connected.",
    TypAutentizace_ISDS_INVALID: "ISDS not connected.",
    ProcessLoginPage_procesPrihlaseni: "Logging",
    ProcessLoginPage_chybaPrihlaseni: "Login error",
    ProcessLoginForm_button_dokoncitPrihlaseni: "Finish login",
    ProcessLoginPage_action_opakovatPrihlaseni: "Repeat login",
    ProcessLoginPage_action_zmenitPrihlaseni: "Change login method",
    ProcessLoginPage_loginError: "Login failed. Try it later. ",
    ProcessLoginPage_maloDat1: "Reguired data for login were not provided. ",
    ProcessLoginPage_maloDat2: "Repeat login, please. ",
    ProcessLoginPage_registraceJmenoHesloNotSupported: "Registration for the username/ password login method has to be done at the local authority office. ",
    ProcessLoginPage_nepredano: "not provided",
    ProcessLoginPage_predano: "provided",
    ProcessLoginPage_malaUroven: "Level of Assurance of the account is too low. ",
    ProcessLoginPage_jmeno: "Name",
    ProcessLoginPage_prijmeni: "Surname",
    ProcessLoginPage_datumNarozeni: "Date of birth",
    ProcessLoginPage_adresa: "Address",
    ProcessLoginPage_urovenDuveryhodnosti: "Level of Assurance",
    ProcessLoginPage_nodata_jmenoPrijmeni: "Name and surname were not provided",
    ProcessLoginPage_nodata_adresa: "Address was not provided",
    ProcessLoadingPage: "Loading...",
    Validation_fieldRequired: "This field is required",
    WaitingMessage: "Processing your request...",
    MoreInformation: "More information",
    TypNotifikace_TELEFON: "Phone notification",
    TypNotifikace_EMAIL: "Email notification",
    TypNotifikace_HROMADNE_OSLOVENI: "I agree to the share personal data to the mass mailing system",
    TypNotifikace_Verify_TELEFON: "Once verified, notifications will be sent to your provided phone number from the Portal",
    TypNotifikace_Verify_EMAIL: "Once verified, notifications will be sent to your provided email address from the Portal.",
    TypNotifikace_SendAgain_TELEFON: "Resend SMS",
    TypNotifikace_SendAgain_EMAIL: "Resend email",
    TypNotifikace_RemainingAttempts_TELEFON: "Remaining attempts: {0}",
    TypNotifikace_RemainingAttempts_NO_TELEFON: "You have exhausted the maximum number of attempts to enter the code, please request a new code",
    TypNotifikace_SendAgain_Info_TELEFON: "A verification code was sent to the phone number '{0}'. Please enter it.",
    TypNotifikace_SendAgain_Info_EMAIL: "A verification code was sent to the email address '{0}'. Please enter it.",
    TypNotifikace_Sent_TELEFON: "A new SMS with a verification code was sent to your mobile phone.",
    TypNotifikace_Sent_EMAIL: "A new email with a verification code was sent to the address",
    TypSouhlasu_REG_GDPR_UCET: "Processing of personal data",
    TypSouhlasu_REG_PLNA_MOC_PORTAL: "Power of attorney",
    TypSouhlasu_REG_PODMINKY_PORTAL: "Portal terms of use",
    TypSouhlasu_REG_PODMINKY_GDPR_PORTAL_PAGE: "Portal terms of use and personal data processing",
    ProfilePage_documentDownloading: "Downloading document",
    ProfilePage_stavNotActivated: "The account has not been activated yet. Please wait for the activation code.",
    ProfilePage_mujProfil: "My profile",
    ProfilePage_ucetDelete: "Permanently delete account",
    ProfilePage_ucetDeleteTitle: "Permanently delete account?",
    ProfilePage_ucetDeleteQuestion1: "Warning, this operation is irreversible! The account and all represented entities will be permanently deleted.",
    ProfilePage_ucetDeleteQuestion2: "Warning, this operation is irreversible! The account will be permanently deleted.",
    ProfilePage_ucetDeleteAction: "Permanently delete",
    ProfilePage_ucetDeleteSuccessTitle: "Account deletion",
    ProfilePage_ucetDeleteSuccessMessage: "Your account has been successfully deleted.",
    ProfilePage_actionFailed: "Action processing failed.",
    ProfilePage_loginTypes: "Login methods",
    ProfilePage_actionInaccessible: "This action is currently unavailable due to maintenance.",
    ProfilePage_dataInaccessible: "Some data and actions are currently unavailable due to maintenance.",
    ProfilePage_notificationReminder: "Enable notifications for payment and billing overviews. We’ll remind you in time.",
    ProfilePage_baseEditEmailTitle: "Edit email",
    ProfilePage_baseEditTelefonTitle: "Edit phone number",
    ProfilePage_baseTitle: "Basic information",
    ProfilePage_baseJmenoPrijmeni: "Name and surname",
    ProfilePage_baseDatumNarozeni: "Date of birth",
    ProfilePage_baseAdresa: "Address",
    ProfilePage_baseDoklad: "Papers number",
    ProfilePage_baseEmail: "Email",
    ProfilePage_baseTelefon: "Phone",
    ProfilePage_baseTelefonEdit: "Edit phone",
    ProfilePage_baseEmailEdit: "Edit email",
    ProfilePage_baseSouhlasy: "Consents",
    ProfilePage_baseKontaktyAktualizovany: "Contact information has been updated",
    ProfilePage_baseKontaktyTitle: "Contacts",
    ProfilePage_baseYmenitKontakty: "Change contacts",
    ProfilePage_loginType: "Login method",
    ProfilePage_loginRegistered: "Registration",
    ProfilePage_loginLastLogin: "Last login",
    ProfilePage_changePassword: "Change password",
    ProfilePage_smsConfirm: "SMS verification",
    ProfilePage_smsConfirmEnterCode: "Enter the 4-digit code we sent to your mobile phone {0}",
    ProfilePage_smsConfirmEnterCodeRemainingAttempts: "Remaining attempts: {0}",
    ProfilePage_smsConfirm_SendAgain: "Send SMS again",
    ProfilePage_smsConfirmRemainingAttempts_NO: "You have used the maximum number of attempts to enter the code, please request a new code",
    ProfilePage_smsConfirmVerify: "Verify code",
    ProfilePage_smsConfirmCodePlaceholder: "Verification code",
    ProfilePage_smsConfirmCodeNotValid: "The entered SMS code is not correct",
    ProfilePage_smsConfirm_Sent: "A new SMS with a verification code has been sent to your mobile phone",
    ProfilePage_passwordChangeDialogTitle: "Change password",
    ProfilePage_passwordChangeCurrentPassword: "Current password",
    ProfilePage_passwordChangeNewPassword: "New password",
    ProfilePage_passwordChangeNewPassword2: "Repeat new password",
    ProfilePage_passwordChangeDo: "Change",
    ProfilePage_passwordChangeNoNewAttempts: "All password change attempts have been used. The action will be available later.",
    ProfilePage_passwordChangeNoNewAttemptsTitle: "Password change attempts exhausted",
    ProfilePage_passwordChanged: "Password has been changed",
    ProfilePage_notificationOvereni: "Contact verification",
    ProfilePage_notificationEnabled: "Enabled",
    ProfilePage_notificationDisabled: "Disabled",
    ProfilePage_notificationEnable: "Enable",
    ProfilePage_notificationDisable: "Disable",
    ProfilePage_notificationChange: "Change",
    ProfilePage_notificationVerify: "Verify",
    ProfilePage_notificationVerified: "Verified",
    ProfilePage_notificationNezobrazovatNotifikace: "Don't show again",
    ProfilePage_notificationSkipSettings: "Skip settings",
    ProfilePage_notificationKontaktNotVerified: "Contact not verified",
    ProfilePage_notificationEnableTitle: "Enable notifications",
    ProfilePage_emailVerificationTitle: "Email verification",
    ProfilePage_notificationVerifyVerifyAndEnable: "Verify and enable",
    ProfilePage_notificationVerifyTitle: "Enable notifications",
    ProfilePage_notificationWrongCode: "The code is incorrect",
    ProfilePage_pristupyLabel: "People you have access to",
    ProfilePage_pristupyAdd: "Add people",
    ProfilePage_pristupyAddDeti: "Minor children",
    ProfilePage_pristupyAddOsvc: "Self-employed (OSVČ)",
    ProfilePage_pristupyPerson: "Other individuals",
    ProfilePage_pristupyDatumZadosti: "Application date",
    ProfilePage_pristupyDatumZadostiBez: "No application",
    ProfilePage_pristupyEmail: "Email",
    ProfilePage_pristupyTyp: "Access type",
    ProfilePage_pristupyTypVazby: "Relationship type",
    ProfilePage_pristupyDokumenty: "Documents",
    ProfilePage_pristupyDalsi: "Other accesses",
    ProfilePage_pristupyAddPristup: "Add access",
    ProfilePage_pristupyTypOboustranny: "Mutual",
    ProfilePage_pristupyTypJednostranny: "One-way",
    ProfilePage_pristupy_AddOSVC: "Add access to self-employed person",
    ProfilePage_pristupy_AddChild: "Add access to minor child",
    ProfilePage_pristupy_AddFO: "Add access to individual",
    ProfilePage_pristupy_deleteTitle: "Permanently delete access?",
    ProfilePage_pristupy_deleteQuestion: "Do you really want to remove access?",
    ProfilePage_pristupy_delete: "Remove access",
    ProfilePage_pristupy_zadostPrijmout: "Accept",
    ProfilePage_pristupy_zadostZamitnout: "Reject",
    ProfilePage_pristupy_zadostQuestion: "Do you really want to '{0}' the access request?",
    ProfilePage_pristupy_zadostTitleAccept: "Accept access request",
    ProfilePage_pristupy_zadostTitleReject: "Reject access request",
    ProfilePage_pristupy_zadostStornoQuestion: "Do you really want to cancel the access request?",
    ProfilePage_pristupy_zadostStornoTitle: "Cancel access request?",
    ProfilePage_pristupy_zadostStorno: "Cancel",
    ProfilePage_pristupy_zadostDatumVyprseni: "Request expiration date",
    ProfilePage_ucetAktivace: "Account activation",
    ProfilePage_ucetAktivovan: "The account has been activated",
    ProfilePage_ucetAktivaceDesc: "To complete registration, enter the activation code.",
    ProfilePage_ucetAktivaceKod: "Activation code",
    ProfilePage_ucetAktivaceAktivovat: "Activate",
    TypVazbyInfo_SAM_K_SOBE: "Self",
    TypVazbyInfo_PRIMY_ZASTUPCE: "Direct representative",
    TypVazbyInfo_NEPRIMY_ZASTUPCE: "Indirect representative",
    TypVazbyInfo_RODIC: "Parent",
    SubjektForm_ico: "Identification Number",
    SubjektForm_jmeno: "First name",
    SubjektForm_prijmeni: "Surname",
    SubjektForm_datumNarozeni: "Date of birth",
    SubjektForm_pristup_oboustrannyPristup: "Mutual access",
    SubjektForm_adresa: "Address",
    SubjektForm_adresaSearch: "Search address...",
    SubjektForm_IsChildValidation: "The child must be under 18 years old",
    SubjektForm_datumNarozeniMinulost: "The date of birth must be in the past",
    SubjektForm_email: "E-mail",
}
